import { SHADOWS } from 'styles/Colors';
import Print from 'images/Print.svg';
import React from 'react';

const state = window.AppConfig.state || {};

const headerStyle = {
  padding: '1rem',
  boxShadow: `0 4px 8px ${SHADOWS}`,
  display: 'flex',
  justifyContent: 'space-between',
  ul: {
    paddingLeft: '1.25rem'
  },
  fontFamily: 'Arimo',
  fontSize: '14px'
};

const printButtonStyle = {
  fontWeight: 'bold',
  fontSize: '1.25rem',
  display: 'inline-flex',
  lineHeight: '1.25rem',
  cursor: 'pointer',
  background: 'none',
  border: 'none'
};

const printIconStyle = {
  height: '3.25rem'
};

const bodyHeaderStyle = {
  textAlign: 'center',
  p: {
    paddingBottom: '0.5rem'
  }
};

const hardwareReqBulletStyle = {
  padding: '1rem 0 1rem 2rem'
};

const elecCommContent = {
  header: (
    <h3 css={headerStyle}>
      <div>
        By checking the box below, I consent to the terms of:
        <ul>
          <li>
            The Arbitration Clause provided&nbsp;
            <a href='#arbitration-agreement'>here</a>
          </li>
          <li>The Electronic Communications Agreement provided below</li>
        </ul>
      </div>
      <button
        data-print-target='electronic-disclosure-body'
        id='ec-print-btn'
        css={printButtonStyle}
        type='button'
      >
        <Print title='print' css={printIconStyle} />
      </button>
    </h3>
  ),
  body: (provider) => {
    const isBankProduct = Boolean(provider);
    return (
      <div id='electronic-disclosure-body'>
        <div css={bodyHeaderStyle}>
          <p>Electronic Communications Agreement</p>
          <p>
            Consent for Electronic Signatures, Records, and Disclosures
            (&quot;E-Consent&quot;)
          </p>
          <p>
            Please read this information carefully and print a copy and/or
            retain this information electronically for future reference.
          </p>
          <br />
        </div>

        <div>
          <p>
            <strong>
              CONSENT TO TRANSACT BUSINESS AND COMMUNICATE ELECTRONICALLY.
            </strong>
            &nbsp;You consent to transact business with&nbsp;
            {isBankProduct && (
              <span>
                {provider}, its successors and assigns as well as OppLoans and
                any other servicing company
              </span>
            )}
            {!isBankProduct && <span>OppLoans and its affiliates</span>}
            &nbsp;through electronic communications in order for us to process
            and service your loan transaction. The following terms and
            conditions govern electronic communications in connection with your
            application, Note and any communications regarding your business
            with us (the &quot;Consent&quot;). By consenting, you agree that we
            may provide electronically any and all disclosures, documents and
            communications regarding our transaction(s) with you including our
            Privacy Policy (&quot;Disclosures&quot;).
          </p>
          <br />
          <p>
            By electronically signing this Note below, you are confirming that
            you have agreed to the terms and conditions of the Consent.
          </p>
          <br />
          <p>
            <strong>Paper Copies of Disclosures.</strong>
            &nbsp;When you apply for and obtain a loan&nbsp;
            {isBankProduct && (
              <span>
                from&nbsp;
                {provider}
              </span>
            )}
            {!isBankProduct && <span>through the OppLoans website</span>}, you
            agree to receive information and disclosures regarding your loan
            electronically. You agree that you are able to view and/or
            electronically store the information presented at this website. You
            also agree you can print out, download or otherwise store the
            Disclosures to keep for your records. If you consent to the
            electronic delivery of Disclosures, you may also receive a paper
            copy of any Disclosure provided to you electronically by writing to
            OppLoans at {state.full_address} or emailing&nbsp;
            <a href={`mailto:${state.loans_email}`}>{state.loans_email}</a>.
            There is no fee for the paper copy.
          </p>
          <br />
          <p>
            <strong>Withdrawing Consent to Electronic Delivery.</strong>
            &nbsp;You may withdraw your consent by sending us your request in
            writing to: OppLoans at {state.full_address} or emailing&nbsp;
            <a href={`mailto:${state.info_email}`}>{state.info_email}</a>.
            &nbsp;If you decide to withdraw your Consent, the legal
            effectiveness, validity and/or enforceability of prior electronic
            Disclosures will not be affected, and there will be no effect on
            your loan.
          </p>
          <br />
          <p>
            <strong>Hardware and Software Requirements.</strong>
            &nbsp;To use the Site and to view documents presented in connection
            with certain of our Products, you will need:
          </p>
          <ul css={hardwareReqBulletStyle}>
            <li>
              A Current Version (defined below) of an Internet browser we
              support;
            </li>
            <li>A connection to the Internet;</li>
            <li>
              A Current Version of a program that accurately reads and displays
              PDF files (which may be either a browser that supports native PDF
              rendering or a program such as Adobe Acrobat Reader); and
            </li>
            <li>
              A computer or mobile device and an operating system capable of
              supporting all of the above.
            </li>
          </ul>
          <br />
          <p>
            By &quot;Current Version&quot;, we mean a version of the software
            that we support and that is currently being supported by its
            publisher. We support the Current Version and, for a period of time
            (at least three (3) months), the version immediately prior to the
            Current Version of Firefox, Google Chrome, Microsoft Edge and
            Safari.
          </p>
          <br />
          <p>
            <strong>Email Requirements.</strong>
            &nbsp;Because we may deliver Disclosures to you or otherwise
            communicate with you using e-mail, you must be able to send e-mail
            and receive e-mail that contains hyperlinks to websites. If you
            provide us with an email address in your application, you may notify
            us of changes in such address by writing to OppLoans at{' '}
            {state.full_address} or sending an email to&nbsp;{' '}
            <a href={`mailto:${state.loans_email}`}>{state.loans_email}</a>.
          </p>
        </div>
      </div>
    );
  },
  footer:
    'I consent to the terms of the Electronic Communications Agreement and the Arbitration Clause.'
};

export default elecCommContent;
